import styled from 'styled-components';

const TableDiv = styled.div`
	@media (max-width: ${(props) => props.$responsive}px) {
		table,
		tbody,
		tr,
		th,
		td {
			display: block;
		}
		colgroup,
		thead {
			display: none;
		}
		tr {
			padding: 10px;
		}
		th,
		td {
			padding: 5px !important;
			height: auto !important;
			text-align: left !important;
		}
		:not(thead) tbody th {
			display: none;
		}
		td {
			display: flex;
		}
		td::before {
			content: attr(data-th) ' : ';
			margin-right: 5px;
			flex-shrink: 0;
		}
		td:has(.gs-no-con)::before,
		td:has(.gs-indicator-con)::before {
			content: none;
		}
		td > * {
			flex: 1;
		}
	}
`;

function Table(props) {
	const { caption, className, minWidth, maxWidth, responsive, children } = props;

	return (
		<TableDiv $responsive={responsive} className={className ? `gs-table ${className}` : 'gs-table'}>
			<table style={{ minWidth: `${minWidth}px`, maxWidth: `${maxWidth}px` }}>
				<caption>{caption}</caption>
				{children}
			</table>
		</TableDiv>
	);
}

export default Table;
